<template>
    <div class="flow" v-html="sidebarContent"></div>
</template>

<script>
    export default {
        data() {
            return {
                sidebarContent: ''
            }
        },
        mounted() {
            const externalElement = document.getElementById('side-blocks')
            if (externalElement) {
                externalElement.style.display = 'block'
                this.sidebarContent = externalElement.innerHTML
                externalElement.remove()
            } else {
                console.warn('Sidebar content element with ID #sidebar-blocks not found.')

            }
        }
    }
</script>